import React, { useContext, useState } from 'react';
import { List, DataColumn, ListHeader } from 'components/lists';
import { useFind } from 'hooks';
import { Context as AuthContext } from 'contexts/auth';
import { Context as CompanyContext } from 'contexts/company';
import { Config } from 'configs';
import { useNavigate } from 'react-router-dom';
import { PageTitle } from 'components/layouts/pageTitle';
import { Pagination } from 'components/lists/pagination';
import { PageContent } from 'components/layouts/pageContent';
import { ListLayout } from 'components/layouts/listLayout';
import { NoRestaurantsBlock } from 'components/blocks/noRestaurants';

export const DeliveryPages = () => {
  const { state: auth } = useContext(AuthContext);
  const navigate = useNavigate();
  const { state: companyState, getCompanyRestaurants, deleteById, shouldDisplayNoRestaurantBlock } = useContext(CompanyContext);
  const [currentPage, setCurrentPage] = useState(1);

  const requestData = {
    secretKey: auth.token,
    collectionName: Config.DATA.COLLECTIONS.DELIVERY_SETTINGS,
    filter: { company: { $eq: { $oid: auth.company?.company } } },
    cultureCode: Config.DEFAULTS.LANGUAGE,
    noFindOnLoad: false,
    loadOnInit: true,
    pageSize: Config.DEFAULTS.PAGE_SIZE,
    pageNumber: currentPage - 1,
  };

  const [findProducts, products, isLoading, totalCount,,, setIsProductsLoading] = useFind(requestData);

  const onEditClicked = (item) => {
    navigate(`/delivery/${item._id}`);
  };

  const finalIsLoading = isLoading === Config.DATA.LOADING_STATUS.INITIAL_LOAD;

  if (isLoading !== Config.DATA.LOADING_STATUS.INITIAL_LOAD && shouldDisplayNoRestaurantBlock()) {
    return <NoRestaurantsBlock />;
  }

  return (
    <ListLayout isLoading={finalIsLoading}>
      <PageTitle title="Delivery" isTopLevel />
      <PageContent>
        <ListHeader title="Delivery pages" description="Delivery pages for restaurants">
          <button
            type="button"
            onClick={() => navigate('/settings/delivery/add-new')}
            className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
          >
            Add new
          </button>
        </ListHeader>
        <List source={products} onRowClick={onEditClicked}>
          <DataColumn
            name="Title"
            dbColumnName="title"
            headerClass="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
            dataCellClass="whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell"
          />
          <DataColumn
            name="Url slug"
            dbColumnName="slug"
            headerClass="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 sm:table-cell"
            dataCellClass="whitespace-nowrap px-3 py-4 text-sm text-gray-500 sm:table-cell"
          />
          <Pagination
            pageSize={Config.DEFAULTS.PAGE_SIZE}
            totalCount={totalCount}
            currentPage={currentPage}
            onPageChanged={async (pageNumber) => {
              await findProducts({ ...requestData, pageNumber: pageNumber - 1 }, false);
              setCurrentPage(pageNumber);
            }}
          />
        </List>
      </PageContent>
    </ListLayout>
  );
};
